import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import axios from 'axios';
import Authenticator from '../authenticator';
import api from 'components/economic-concret/api/api';

export default function Welcome() {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);

    const [patients, setPatients] = useState([]);
    const [selectedPatientId, setSelectedPatientId] = useState('');
    const [reminders, setReminders] = useState([]);

    useEffect(() => {
    }, []);

    return (
        <Card className="bg-transparent-50 overflow-hidden">
            <Authenticator />
            <Card.Header className="position-relative">
                <h5
                    className="mb-0 d-flex justify-content-center texto-negrito"
                    data-anchor="data-anchor"
                >
                    Bem Vindo(a) ao Economic Concrete
                </h5>
                <p className="mt-2 mb-0 d-flex justify-content-center">
                    Sistema de Gestão de Concreto
                </p>
            </Card.Header>
            <Card.Body className="p-0">
                <Form className="row g-3 card-body">
                </Form>
            </Card.Body>
        </Card>
    );
}
